import { mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as Api from '../../../../store/bulk/update/bulk.update.api';
import { BulkActions } from '../../../../enums/bulk-actions';
import { AsyncJobHelper } from '../../../../services/async-job-helper';

const makeApiCallWithIds = (job) => {
  const { bulkUpdateTypeData, ids } = job;

  const request = bulkUpdateTypeData.requestFilter(ids);
  return Api.bulkDoNotNotifyMarketplace(request).pipe(
    mergeMap((data) => {
      const foldedData = AsyncJobHelper.foldMultiJobResponse(data);
      return of(foldedData);
    }),
  );
};

const makeApiCallWithJobGuid = (job) => {
  const {
    jobData: { bulkUpdateJobGuid },
  } = job;

  return Api.bulkUpdateDoNotNotifyMarketplace({ bulkUpdateJobGuid }).pipe(
    mergeMap((data) => {
      return of(data);
    }),
  );
};

export const doNotNotifyMarketplace = {
  id: 'do-not-notify-marketplace',
  applicableBulkActions: [BulkActions.doNotNotifyMarketplace],

  handler: (job) => {
    const {
      jobData: { bulkUpdateJobGuid },
    } = job;

    const makeApiCall$ = bulkUpdateJobGuid ? makeApiCallWithJobGuid : makeApiCallWithIds;

    return makeApiCall$(job);
  },
};
